import $http from "../axios";

const state = {
  lockerDeliveries: [],
  allLockerDeliveriesQty: 0,
  lockerDeliveriesFilter: ""
};

const getters = {
  lockerDeliveries: state => {
    return state.deliveries;
  },
  lockerDeliveriesReverse: state => {
    return JSON.parse(JSON.stringify(state.lockerDeliveries.reverse()));
  },
  lockerDeliveriesFilter: state => {
    return state.lockerDeliveriesFilter;
  },
  allLockerDeliveriesQty: state => {
    return state.allLockerDeliveriesQty;
  }
};

const actions = {
  getLockerDeliveries({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `locker-deliveries?lockerId=${data.lockerId}&filter=${data.filter}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_LOCKER_DELIVERIES", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  makeLockerDeliveryWithCourier({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`make-locker-delivery-with-courier`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("MARK_DOOR_BUSY", res.data.payload.doorId);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  makeLockerDeliveryWithoutCourier({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`make-locker-delivery-without-courier`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("MARK_DOOR_BUSY", res.data.payload.doorId);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  cancelDelivery(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`cancel-delivery`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  openDoor(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`open-door`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  resendDeliveryEmail(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("resend-delivery-email", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateDeliveryEmail(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-delivery-email", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  resendDeliverySMS(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("resend-delivery-sms", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateDeliveryCellphone(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-delivery-cellphone", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateDeliveryInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-delivery-info", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_DELIVERY_INFO", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setLockerDeliveriesFilter({ commit }, filter) {
    commit("SET_LOCKER_DELIVERIES_FILTER", filter);
  }
};

const mutations = {
  SET_LOCKER_DELIVERIES(state, lockerDeliveries) {
    state.lockerDeliveries = lockerDeliveries;
  },

  SET_ALL_LOCKER_DELIVERIES_QTY(state, allLockerDeliveriesQty) {
    state.allLockerDeliveriesQty = allLockerDeliveriesQty;
  },

  UPDATE_DELIVERY_INFO(state, data) {
    const index = state.lockerDeliveries.findIndex(d => {
      return d._id === data.deliveryId;
    });
    state.lockerDeliveries[index].client.personalInfo.name = data.clientName;
    state.lockerDeliveries[index].client.personalInfo.personalId =
      data.clientPersonalId;
    state.lockerDeliveries[index].observations = data.observations;

    if (state.lockerDeliveries[index].courier) {
      state.lockerDeliveries[index].courier.personalInfo.name =
        data.courierName;
      state.lockerDeliveries[index].courier.personalInfo.personalId =
        data.courierPersonalId;
    }
  },

  SET_LOCKER_DELIVERIES_FILTER(state, filter) {
    state.lockerDeliveriesFilter = filter;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
